module.exports = __webpack_public_path__ + "static/media/event.11e232d3.jpg";